import { IFlowResponse } from '../types/server.types';

export interface IReloadAction {
    sessionId: string;
}

export interface IUpdateSocketAction {
    flow: IFlowResponse;
}

export enum FlowInformActionTypes {
    reload = 'reload',
    update = 'update'
}

export interface FlowInformAction {
    type: FlowInformActionTypes;
    data: object;
}
